import LotView from './lot-view'

export default LotView
